// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"e146a905","941":"086190c8"}[chunkId] + ".chunk.css";
};